module.exports = __webpack_public_path__ + "static/media/image-1.6f868ff3.png";